import $vuetify from 'vuetify/es5/locale/pt';

export default {
  $vuetify,
  save: 'Salvar',
  close: 'Fechar',
  delete: 'Deletar',
  confirm: 'Confirmar',
  select: 'Selecionar',
  edit: 'Editar',
  copy: 'Copiar',
  active: 'Ativo',
  inactive: 'Inativo',
  download: 'Baixar',
  deleteAll: 'Deletar Todos',
  unlinkAll: 'Desvincular Todos',
  linkAll: 'Vincular Todos',
  selectAll: 'Selecionar Todos',
  fieldRequired: 'Este campo é obrigatório',
  generatingCsv: 'Gerando Excel',
  dialogDelete: {
    title: 'Deseja deletar o item ?',
    message: 'O item será removido permanentemente, tem certeza que deseja continuar ?',
    observationNote: 'Observação',
    alertTitle: 'Você está prestes a fazer uma exclusão permanentemente!',
    defaultMessage: 'Essa ação não pode ser desfeita.',
  },
  applications: {
    application: 'Aplicativo',
    applications: 'Aplicativos',
    newApplication: 'Novo Aplicativo',
    name: 'Nome',
    description: 'Descrição',
    alias: 'Alias',
    createdSuccess: 'Aplicativo criado',
    updatedSuccess: 'Aplicativo atualizado',
    findError: 'Aplicativo não encontrado',
    removeMessage: 'Tem certeza que deseja remover o aplicativo?',
    removeTitle: 'Remover o aplicativo',
    versions: 'Versões',
  },
  versions: {
    versions: 'Versões',
    version: 'Versão',
    isDefault: 'Versão Padrão',
    name: 'Nome',
    description: 'Descrição',
    url: 'Url',
    findError: 'Versão não encontrada',
    createdSuccess: 'Versão criada',
    updatedSuccess: 'Versão atualizada',
    major: 'Principal (Major)',
    minor: 'Menor (Minor)',
    patch: 'Correção (Patch)',
    generatedAt: 'Data de Geração',
    hidden: 'Ocultar',
    invalidExtension: 'Apenas arquivos .apk são permitidos.',
    fileRequired: 'Você precisa adicionar um aplicativo para criar uma versão',
    dontChangeUrl: 'Manter a mesma Url',
    removeMessage: 'Tem certeza que deseja remover a versão?',
    versionDefault: 'Padrão',
    defaultTooltip: 'Selecionar como versão padrão',
    deleteDefaultVersionMessage: 'Deseja excluir a versão padrão da empresa ?',
    selectDefaultVersionMessage: 'Só é permitido uma versão padrão por empresa, outra versão selecionada será desvinculada, tem certeza que deseja continuar ?',
    numUsers: 'Nº Usuários',
    selectUserVersion: 'Tem certeza que deseja vincular a versão ao usuário?',
    selectAllUserVersion: 'Tem certeza que deseja vincular a versão a todos os usuários?',
    updatedAt: 'Atual. Em',
    fromDeskOffline: 'Desktop (offline)',
  },
  companies: {
    companies: 'Empresas',
    tradingName: 'Nome',
    cnpj: 'CNPJ',
    removeMessage: 'Tem certeza que deseja remover a empresa?',
  },
  companyapplications: {
    companyapplications: 'Aplicativos',
    applications: 'Aplicativos',
    name: 'Nome',
    description: 'Descrição',
    removeMessage: 'Tem certeza que deseja remover o aplicativo?',
  },
  users: {
    users: 'Usuários',
    firstName: 'Nome',
    username: 'Nome de Usuário',
    email: 'Email',
    removeMessage: 'Tem certeza que deseja desvincular a versão do usuário?',
    thereAreVersionsAvailable: 'Existem versões superiores disponiveis',
  },
};
